module.exports = __webpack_public_path__ + "static/media/sell_help_13.229de40d.png";